import { createVNode as _createVNode } from "vue";
/**
 * @author yili
 * @fileoverview 轮播
 */
import _ from "lodash";
import { defineComponent, onMounted, watch, reactive, nextTick } from "vue";
import Swiper from "swiper";
import "swiper/css/swiper.css";

// components
export default defineComponent({
  name: "SwiperBox",
  props: {
    // 轮播信息
    swiperSetInfo: {
      type: Object,
      default: null
    }
  },
  setup(props) {
    const state = reactive({
      mySwiper: null
    });
    watch(() => props.swiperSetInfo, newVal => {
      // state.mySwiper.update();
      if (state.mySwiper) {
        // bool1代表是否销毁swiper实例
        // bool2代表是否销毁swiper样式（导航器、分页器等）
        state.mySwiper.destroy(true, false);
      }
      nextTick(() => {
        initSwiper(newVal.key, newVal.slidesPerView, newVal.initialSlide);
      });
    });
    function initSwiper() {
      state.mySwiper = new Swiper(`.swiper`, {
        autoplay: {
          // disableOnInteraction: false, // 用户操作swiper之后，是否禁止autoplay
          delay: 3000 // 自动切换的时间间隔（单位ms）
        },

        slidesPerView: 3,
        initialSlide: 2,
        //设定初始化时slide的索引,下标从0开始
        spaceBetween: 0,
        //间隔
        loop: true,
        // 是否循环轮播
        breakpoints: true,
        zoom: true,
        circular: true,
        // 是否采用衔接滑动
        parallax: true,
        centeredSlides: true,
        // 居中
        speed: 500,
        watchOverflow: true,
        //当没有足够的slide切换时,默认不开启这个功能
        pagination: {
          el: ".swiper-pagination",
          type: "bullets",
          bulletClass: "swiper-pagination-bullet",
          //激活样式
          bulletActiveClass: "my-bullet-active"
        }
      });
    }
    onMounted(() => {
      if (props.swiperSetInfo.key) {
        initSwiper(props.swiperSetInfo.key, props.swiperSetInfo.slidesPerView, props.swiperSetInfo.initialSlide);
      }
    });
    return () => {
      const item = _.map(props.swiperSetInfo.slideList, item => {
        return _createVNode("div", {
          "class": "swiper-slide"
        }, [_createVNode("img", {
          "src": require(`@/assets/img/pc/${item}`)
        }, null)]);
      });
      return _createVNode("div", {
        "class": "pc-information"
      }, [_createVNode("div", {
        "class": `swiper ${props.swiperSetInfo.key}`
      }, [_createVNode("div", {
        "class": "swiper-wrapper"
      }, [item]), _createVNode("div", {
        "class": "swiper-pagination"
      }, null)])]);
    };
  }
});